import { Component, AfterViewInit, ElementRef, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'gcs-loading-spinner',
    templateUrl: './gcs-loading-spinner.component.html',
    styleUrls: ['./gcs-loading-spinner.component.css']
})

export class GCSLoadingSpinnerComponent {

    @Input() show:boolean = false;
    @Input() opacity: boolean = false;

    constructor() {
        
    }
}